module.exports = __webpack_public_path__ + "img/artificial-intelligence-ai-icon.ad724e9f.svg";